// src/pages/ConsumptionTrend.jsx
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import useFetch from '../../hooks/useFetch';
import { logout } from '../../redux/actions/authActions';
import { useNavigate } from 'react-router-dom';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const SmartyConsumptionTrend = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn, user, token } = authState;
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    if (!isLoggedIn) return;
    const config = {
      url: "/smartyitems/aggregate",
      method: "post",
      headers: { Authorization: token },
      data: { userId: user._id, year: currentYear, status_ne: 'Expired', groupBy: 'month', sum: 'amount' }
    };
    fetchData(config).then(response => {
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const labels = months;
      const data = months.map((_, i) => response.data[i + 1] || 0); // Assume backend returns array indexed by month
      setChartData({
        labels,
        datasets: [{
          label: 'Monthly Consumption (₹)',
          data,
          backgroundColor: 'rgba(75, 192, 192, 0.6)',
          borderColor: 'rgba(75, 192, 192, 1)',
          borderWidth: 1
        }]
      });
    });
  }, [fetchData, isLoggedIn, token, user, currentYear]);

  if (loading) return <div>Loading Chart...</div>;

  return (
    <div className="min-h-screen bg-black text-blue-100 p-4">
      <h1 className="text-2xl font-bold text-yellow-200 mb-4">Consumption Trend {currentYear}</h1>
      <div className="w-full max-w-4xl mx-auto">
        <Bar data={chartData} options={{ responsive: true, plugins: { legend: { position: 'top' } } }} />
      </div>
    </div>
  );
};

export default SmartyConsumptionTrend;